import { capability } from './glyphs/capability';
import { capabilityTab } from './glyphs/capability-tab';
import { core } from './glyphs/core';
import { logic } from './glyphs/logic';
import { system } from './glyphs/system';

export const glyph = {
  capability,
  capabilityTab,
  core,
  logic,
  system,
} as const;

export type GlyphType = typeof glyph;
